import { Controller } from "stimulus";

export default class extends Controller {

  static get targets() {
    return ["checkbox", "input"];
  }

  static get values() {
    return { omitSwitchedOff: Boolean };
  }

  connect() {
    this.checkboxTargets.forEach((checkbox) => {
      this.toggleInput(checkbox);
    });
    this._listenForSubmit();
  }

  disconnect() {
    if (this._onSubmit) this._form.removeEventListener("submit", this._onSubmit);
  }

  toggle(event) {
    this.toggleInput(event.target);
  }

  toggleInput(checkbox) {
    const input = this.inputTargets.find((input) => input.dataset.id === checkbox.dataset.id);

    if (!input) return;

    if (checkbox.checked) {
      input.classList.remove("dn");
    } else {
      input.classList.add("dn");
    }
  }

  handleSubmit() {
    this.checkboxTargets.forEach((checkbox) => {
      const input = this.inputTargets.find((input) => input.dataset.id === checkbox.dataset.id);

      if (!checkbox.checked) {
        input.querySelector("input").value = "";
      }
    });
  }

  // With omitSwitchedOff, the fields under a switched-off checkbox are left out of the submit, so
  // choices made while it was on and then hidden are not sent. Hiding a field does not stop it
  // posting, so they are disabled for the submit only: decided from the live checkbox state, by a
  // listener on the form that runs before hanamiUjs's document-level one builds the FormData, and
  // enabled again on the next tick so the choices are still there if the switch goes back on.
  _listenForSubmit() {
    if (!this.omitSwitchedOffValue) return;

    this._form = this.element.closest("form");
    if (!this._form) return;

    this._onSubmit = () => this._omitSwitchedOffFields();
    this._form.addEventListener("submit", this._onSubmit);
  }

  _omitSwitchedOffFields() {
    const omitted = this.checkboxTargets
      .filter((checkbox) => !checkbox.checked)
      .flatMap((checkbox) => this._fieldsFor(checkbox))
      .filter((field) => !field.disabled);

    if (omitted.length === 0) return;

    omitted.forEach((field) => {
      field.disabled = true;
    });
    setTimeout(() => {
      omitted.forEach((field) => {
        field.disabled = false;
      });
    }, 0);
  }

  _fieldsFor(checkbox) {
    const input = this.inputTargets.find((input) => input.dataset.id === checkbox.dataset.id);

    return input ? [...input.querySelectorAll("input, select, textarea")] : [];
  }
}
